import { Stack, Typography } from '@mui/material';
import { shorterDateFormat } from 'Config';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';

interface IInformation {
  docSubject: string | undefined;
  docDate: string;
}

export const Information = ({ docSubject, docDate }: IInformation) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Documents);

  return (
    <Stack direction='row' mb='20px'>
      {docSubject && (
        <Stack>
          <Typography variant='body6'>{dictionary.fileType}</Typography>
          <Typography variant='body2'>{docSubject}</Typography>
        </Stack>
      )}
      <Stack>
        <Typography variant='body6'>{dictionary.sentDate}</Typography>
        <Typography variant='body2'>
          {docDate ? format(new Date(docDate), shorterDateFormat) : ''}
        </Typography>
      </Stack>
    </Stack>
  );
};
